import React from "react";
import Button from "antd/lib/button";
import Spin from "antd/lib/spin";
import Icon from "antd/lib/icon";

const Input = ({
  value = "",
  isFetching = false,
  onValueChange = () => alert("onValueChange is not being passed"),
  onSearch = () => alert("onSearch is not being passed")
}) => {
  const antIcon = <Icon type="loading" style={{ fontSize: 72 }} spin />;
  const loading = <Spin indicator={antIcon} />;
  const content = isFetching ? (
    loading
  ) : (
    <textarea
      defaultValue={value}
      data-hj-whitelist
      name="textarea"
      className="input-textarea"
      autoComplete="off"
      onChange={e => onValueChange(e.target.value)}
      placeholder="#travel #nyc #wanderlust #explore #adventure #sunset #skyline"
      ref={input => (this.input = input)}
    />
  );

  const currentCount = !!value ? value.split(" ").length : 0;
  const isDisabled = !currentCount || isFetching;
  return (
    <div className="Input">
      <div className="input-headingContainer">
        <h3>Input</h3>
      </div>
      <div className="input-textareaContainer">{content}</div>
      <div className="searchButtonContainer">
        <Button
          className="searchButton"
          icon="search"
          disabled={isDisabled}
          onClick={() => onSearch(value)}
        >
          Search
        </Button>
      </div>
    </div>
  );
};

export default Input;



// WEBPACK FOOTER //
// ./src/Input.js